import { type ComponentProps } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ProductDetailsButton } from '../ProductDetailsButton';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsChangeLocationButton = (props: Props) => {
  const { formatMessage } = useIntl();

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ProductDetailsButton
      accessibilityLabel={formatMessage(messages.title)}
      {...props}
    >
      {formatMessage(messages.title)}
    </ProductDetailsButton>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Change location to order',
    description: 'Product Details | Change location to order button | Title',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<
  ComponentProps<typeof ProductDetailsButton>,
  'style' | 'children'
>;
